import React from "react";
import { Link } from "react-router-dom";
import "./sudanLanding.scss";
import { useLanguage } from "../i18n/LanguageContext";

const STEPS = [
   {
      title: "Register for free",
      text: "Sign up for your dedicated KAPorg Sudan account. No cost, no obligation."
   },
   {
      title: "Self-assessment",
      text: "Assess your organization and get instant feedback and a tailored action plan."
   },
   {
      title: "Build capacity",
      text: "Access resources and track improvement over time."
   },
   {
      title: "Apply for the program",
      text: "Join the annual 4-week guided program. Open to 20 organizations."
   },
   {
      title: "Get certified",
      text: "Receive your KAPorg certificate recognized by UN agencies and donors."
   }
];

const Pathway = () => {
   const { t } = useLanguage();
   return (
      <section className="sd-section sd-pathway" id="how-it-works">
         <div className="container">
            <div className="sd-section-head">
               <h2>{t("From sign-up to certification — entirely free.")}</h2>
               <p>
                  {t(
                     "KAPorg walks Sudanese organizations through a structured pathway that builds, documents, and certifies organizational capacity."
                  )}
               </p>
            </div>

            <div className="sd-steps">
               {STEPS.map((step, index) => (
                  <div className="sd-step" key={step.title}>
                     <div className="sd-step-num">{index + 1}</div>
                     <h4>{t(step.title)}</h4>
                     <p>{t(step.text)}</p>
                  </div>
               ))}
            </div>

            <div className="sd-pathway-cta">
               <Link to="/auth/registration" className="sd-btn sd-btn-primary">
                  {t("Register for free")}
               </Link>
               <a href="mailto:info@kaptechgroup.com" className="sd-btn sd-btn-secondary">
                  {t("Book a demo")}
               </a>
            </div>
         </div>
      </section>
   );
};

export default Pathway;
